import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';

const HEADER_OFFSET = 132;
const BUBBLE_KEY = 'duc_chatbubble_dismissed';

function scrollToSection(sectionId: string) {
  const el = document.querySelector(sectionId);
  if (el) {
    const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}

function ChatAgentBubble() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(BUBBLE_KEY) === '1') return;
    } catch { /* ignore */ }
    // Toon de bubbel na 2 seconden
    const t = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { sessionStorage.setItem(BUBBLE_KEY, '1'); } catch { /* ignore */ }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 8 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.85, y: 8 }}
          transition={{ type: 'spring', stiffness: 280, damping: 22 }}
          className="fixed bottom-20 right-4 md:right-6 z-[9960] flex flex-col items-end"
        >
          <div
            className="relative bg-[#0A1628] text-white rounded-2xl rounded-br-sm px-4 py-3 max-w-[200px] cursor-pointer"
            style={{ boxShadow: '0 4px 20px rgba(10,22,40,0.30)' }}
            onClick={dismiss}
          >
            {/* Sluit knop */}
            <button
              onClick={(e) => { e.stopPropagation(); dismiss(); }}
              className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center rounded-full bg-[#0A1628] border border-white/20 text-white/60 hover:text-white transition-colors cursor-pointer"
              aria-label="Sluiten"
            >
              <i className="ri-close-line text-[10px]" />
            </button>

            {/* Tekst */}
            <div className="flex items-center gap-2 mb-1">
              <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#3B9EE8]/20 flex-shrink-0">
                <i className="ri-robot-line text-[#3B9EE8] text-[10px]" />
              </div>
              <span className="text-[#3B9EE8] text-[10px] font-600 uppercase tracking-wide">AI Agent</span>
            </div>
            <p className="text-white text-xs font-500 leading-snug">Live chat met onze AI Agent</p>

            {/* Pijltje naar rechtsonder (wijst naar chatbot knop) */}
            <div
              className="absolute -bottom-2 right-3 w-0 h-0"
              style={{
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: '8px solid #0A1628',
              }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default function FloatingCTA() {
  const [showOfferte, setShowOfferte] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      setShowOfferte(scrolled > 0.25);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleOfferteClick = () => {
    if (location.pathname === '/') {
      scrollToSection('#contact');
    } else {
      navigate('/contact');
    }
  };

  return (
    <>
      <ChatAgentBubble />
      {/* Gratis offerte knop — desktop only, boven de WhatsApp knop */}
      <div className="hidden md:flex fixed bottom-20 left-5 z-[900] flex-col items-start gap-3">
        <AnimatePresence>
          {showOfferte && (
            <motion.button
              initial={{ opacity: 0, x: -40, scale: 0.85 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: -40, scale: 0.85 }}
              transition={{ duration: 0.3, ease: 'easeOut' }}
              onClick={handleOfferteClick}
              className="flex items-center gap-2 bg-[#0A1628] hover:bg-[#0D2147] text-white text-xs font-700 px-4 py-2.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ boxShadow: '0 4px 20px rgba(10,22,40,0.25)' }}
            >
              <i className="ri-file-list-3-line text-sm" />
              Gratis offerte
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </>
  );
}